// Used in assign-review.component.ts

import { SubjectId } from "@carnegie-learning/common-types";
import { createAction, props } from "@ngrx/store";

// ------ Load classes ------
export const loadClassesForSubject = createAction(
    "[Cart Classes] Load Classes For Language",
    props<{ subjectId: SubjectId }>()
);
export const loadClassesForSubjectFail = createAction(
    "[Cart Classes] Load Classes Fail",
    props<{ payload: any }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadClassesForSubjectSuccess = createAction(
    "[Cart Classes] Load Classes Success",
    props<{ payload: any /*CoursePagination*/ }>()
);
